import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { BarChart } from '../../shared/charts';

import '../dashboard.scss';

const CaseHospitalsChart = ({ cases = [] }) => {
  const buildHospitalData = (cases, topN = 5) => {
    const map = {};

    cases.forEach((c) => {
      const name = c?.hospital || 'Unknown';
      map[name] = (map[name] || 0) + 1;
    });

    const sorted = Object.entries(map)
      .sort((a, b) => b[1] - a[1])
      .slice(0, topN);

    return sorted.map(([hospital, count]) => ({
      hospital,
      cases: count,
    }));
  };

  const data = useMemo(() => {
    return buildHospitalData(cases, 5).map((item) => {
      const shortName = item.hospital
        .split(' ')
        .slice(0, 2)
        .join(' ');

      return {
        name: shortName,
        Cases: item.cases,
      };
    });
  }, [cases]);

  return (
    <Box className="dashboard-graph-container">
      <div className="table-title-container">
        <div className="flex-1">
          <div className="d-flex">
            <Box>
              <Box className="table-title">
                Cases
                <Box className="badge">by hospital</Box>
              </Box>

              <Box className="table-subtitle">
                Top 5 hospitals (last 30 days)
              </Box>
            </Box>
          </div>
        </div>
      </div>

      <Box sx={{ padding: '0 24px 16px 0' }}>
        <BarChart
          data={data}
          datasets={[
            {
              key: 'Cases',
            },
          ]}
        />
      </Box>
    </Box>
  );
};

CaseHospitalsChart.propTypes = {
  cases: PropTypes.array,
};

export default memo(CaseHospitalsChart);